import { makeAutoObservable, runInAction } from 'mobx';

import { EmailNotificationEvent } from 'common/enums/emailNotifications.enums';

import { UserEmailNotificationsApi } from './userEmailNotifications.api';
import { UserEmailNotificationsResponseDto } from './userEmailNotifications.dto';

class UserEmailNotificationsStore {
  UserEmailNotificationsApi: UserEmailNotificationsApi;

  isLoading = false;

  notifications: UserEmailNotificationsResponseDto | null;

  constructor() {
    this.UserEmailNotificationsApi = new UserEmailNotificationsApi();
    this.notifications = null;

    makeAutoObservable(this, {}, { autoBind: true });
  }

  public async getNotifications() {
    this.isLoading = true;

    try {
      const response = await this.UserEmailNotificationsApi.getNotifications();

      runInAction(() => {
        this.notifications = response;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async createNotifications(events: EmailNotificationEvent[]) {
    this.isLoading = true;

    try {
      await this.UserEmailNotificationsApi.createNotifications(events);
      await this.getNotifications();
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async updateNotifications(events: EmailNotificationEvent[]) {
    this.isLoading = true;

    try {
      await this.UserEmailNotificationsApi.updateNotifications(events);
      await this.getNotifications();
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default UserEmailNotificationsStore;
